import { render, staticRenderFns } from "./ActivateCareDialog.vue?vue&type=template&id=21304284&scoped=true"
import script from "./ActivateCareDialog.vue?vue&type=script&lang=js"
export * from "./ActivateCareDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivateCareDialog.vue?vue&type=style&index=0&id=21304284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21304284",
  null
  
)

export default component.exports